import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: DeliveryProvider | null = initialState,
  action: ActionType<typeof currentOrder>,
): DeliveryProvider | null {
  switch (action.type) {
    case getType(currentOrder.setDeliveryProvider): {
      const { value } = action.payload;
      return value || initialState;
    }
    case getType(currentOrder.applyBufferData): {
      const { deliveryProvider } = action.payload.value;
      return deliveryProvider === undefined ? state : deliveryProvider;
    }
    default:
      return state;
  }
}
